<template>
    <div>
        <div class="p-4 shadow bg-white">
            <div class="mx-auto max-w-3xl">
                <div class="flex items-center justify-between">
                    <h1 class="text-2xl font-extrabold">
                        <InertiaLink href="/">
                            <img src="/images/logos/camaq.webp" alt="CAMAQ" class="h-16 w-32 object-contain" />
                        </InertiaLink>
                    </h1>

                    <button
                        class="hamburger"
                        :class="[showMenu ? 'is-active' : '']"
                        @click="showMenu = !showMenu"
                    >
                        <span class="line"></span>
                        <span class="line"></span>
                        <span class="line"></span>
                    </button>
                </div>
            </div>
        </div>

        <transition name="slide">
            <div v-if="showMenu" class="fixed inset-y-0 left-0 z-50 w-2/3 overflow-y-scroll bg-white px-4 shadow md:w-1/2">
                <div class="mt-4">
                    <p class="text-sm uppercase tracking-wide text-camaq-700">Site</p>

                    <div class="mt-4 space-y-2">
                        <InertiaLink href="/" class="block rounded-md p-2 hover:bg-camaq-50">{{ $t('Home') }}</InertiaLink>
                        <InertiaLink v-for="link in links" :key="link.url" :href="link.url" class="block rounded-md p-2 hover:bg-camaq-50">{{ link.name }}</InertiaLink>

                        <a :href="$page.props.otherLocaleUrl" class="mt-4 block rounded-md p-2 font-medium text-primary">
                            {{ $page.props.locale === 'fr' ? 'EN' : 'FR' }}
                        </a>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script setup>
    import { usePage } from '@inertiajs/inertia-vue3';
    import { trans } from 'laravel-vue-i18n';
    import { ref } from 'vue';

    const showMenu = ref(false);

    const locale = usePage().props.value.locale;
    const prefix = locale === 'en' ? '/en' : '';

    const links = [
        { name: trans('Job opportunities'), url: locale == 'fr' ? '/emplois' : `${prefix}/job-opportunities` },
        { name: 'Formations', url: `${prefix}/formations` },
        { name: trans('Internships'), url: locale == 'fr' ? '/stages' : `${prefix}/internships` },
        { name: trans('Events'), url: locale == 'fr' ? '/evenements' : `${prefix}/events` },
    ];
</script>
